export function useExternalLinks(selector = '.description a') {
    if (!process.client) {
        return;
    }
    const router = useRouter();
    const links = document.querySelectorAll(selector)
    links.forEach(link => {
        link.addEventListener('click', (event) => {
            event.preventDefault()
            const href = link.getAttribute('href');
            const locale = useNuxtApp().$i18n.locale.value;

            const startIndex = href.indexOf(`/${locale}`) + `/${locale}`.length;
            const finalHref = href.substring(startIndex);

            if (finalHref) {
                router.push(`/${locale}${finalHref}`);
            }
        })
    })
}
